import 'core-js/stable/array/from';
import 'core-js/stable/array/flat-map';

class Rating {
	constructor(form) {
		const
			criterions = Array.from(form.querySelectorAll('.criterion')).map(
				container => new Criterion(container)
			),
			submit_button = form.querySelector('button[type="submit"]');

		criterions.flatMap(criterion => criterion.radio_inputs).forEach(
			radio_input => {
				radio_input.addEventListener('change', () => {
					if (criterions.every(criterion => criterion.is_checked)) {
						submit_button.disabled = false;
					}
				});
			}
		);
	}
}

class Criterion {
	constructor(container) {
		this.radio_inputs =
			Array.from(container.querySelectorAll('input[type="radio"]'));
	}

	get is_checked() {
		return this.radio_inputs.some(radio_input => radio_input.checked);
	}
}

export { Rating };
